// test1846
(1846 && 0);
